export default __webpack_public_path__ + "static/media/video3.f0aef128.webp";